const FormBannerReducer = (state, action) => {
	switch (action.type) {
		case "UPDATE": {
			return {
				surveyBanner: action.payload,
			};
		}
		case "CLEAR": {
			return {
				surveyBanner: null,
			};
		}

		default:
			return state;
	}
};

export default FormBannerReducer;
